// src/pages/ProjectPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Home from './Home';
import { fetchJobs, fetchProjects } from '../utils/cmsAPI';
import { getCompanySlug, getProjectSlug } from '../utils/slugUtils';

const ProjectPage = () => {
  const { companySlug, projectSlug } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProject = async () => {
      try {
        const [jobs, projects] = await Promise.all([
          fetchJobs(),
          fetchProjects({ published: true })
        ]);

        // Find job by company slug
        const foundJob = jobs.find(j => getCompanySlug(j.company) === companySlug);
        
        if (!foundJob) {
          navigate('/', { replace: true });
          return;
        }

        // Find projects associated with this job
        const associatedProjects = projects.filter(p => {
          return (
            p.associated_job === foundJob.id ||
            p.associated_job === foundJob.company ||
            String(p.associated_job) === String(foundJob.id)
          );
        });

        // Find the specific project by slug
        const foundProject = associatedProjects.find(p => getProjectSlug(p) === projectSlug);

        if (foundProject) {
          setJob(foundJob);
          setProject({
            ...foundProject,
            content: foundProject.body || foundProject.content
          });
        } else {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Failed to fetch project:', error);
        navigate('/', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    if (companySlug && projectSlug) {
      loadProject();
    }
  }, [companySlug, projectSlug, navigate]);

  // Pass the job and project to Home component which will open the drawer
  return <Home job={job} project={project} loading={loading} />;
};

export default ProjectPage;

